export interface HeroSlide {
  id: string;
  tag: string;
  title: string;
  desc: string;
  image: string;
  to: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 'slide-001',
    tag: '焦点推荐',
    title: '星海拾荒者',
    desc: '星环带的尽头，藏着一个被遗忘的文明。少女拾荒者的冒险，从这里开始。',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20abstract%20space%20illustration%20of%20a%20lone%20figure%20in%20a%20glowing%20green%20nebula%20surrounded%20by%20floating%20spaceship%20debris%2C%20deep%20teal%20and%20emerald%20tones%20with%20dark%20vignette%20for%20strong%20text%20contrast%2C%20painterly%20cel%20shaded%20style%2C%20wide%20landscape%20composition&width=1600&height=900&seq=hero-slide-001&orientation=landscape',
    to: '/detail/comics/comic-001',
  },
  {
    id: 'slide-002',
    tag: '本周新番',
    title: '魔法便利店',
    desc: '魔药、龙鳞、会说话的饭团，还有打折的关东煮——今晚你来点幸运吗？',
    image:
      'https://readdy.ai/api/search-image?query=cozy%20fantasy%20illustration%20of%20a%20glowing%20convenience%20store%20at%20night%20with%20colorful%20potions%20on%20shelves%2C%20warm%20amber%20and%20emerald%20accents%20against%20a%20dark%20surrounding%2C%20soft%20painterly%20style%20with%20clear%20dark%20edges%20for%20text%20contrast%2C%20wide%20landscape%20composition&width=1600&height=900&seq=hero-slide-002&orientation=landscape',
    to: '/detail/comics/comic-005',
  },
  {
    id: 'slide-003',
    tag: '最新资讯',
    title: '《星海拾荒者》动画化确定',
    desc: '2027年春季开播，原作者全程监修，先导预告已公开。',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20anime%20announcement%20key%20visual%20with%20glowing%20green%20speed%20lines%20and%20a%20silhouette%20against%20a%20dark%20gradient%20sky%2C%20cinematic%20dramatic%20mood%2C%20painterly%20cel%20shaded%20style%2C%20wide%20landscape%20composition&width=1600&height=900&seq=hero-slide-003&orientation=landscape',
    to: '/detail/news/news-001',
  },
  {
    id: 'slide-004',
    tag: '人气连载',
    title: '爆改系统上线',
    desc: '外卖小哥绑定逆袭系统，一步步把人生这场游戏打通关。',
    image:
      'https://readdy.ai/api/search-image?query=energetic%20urban%20fantasy%20illustration%20of%20a%20young%20man%20surrounded%20by%20floating%20holographic%20green%20interface%20panels%20against%20a%20dark%20night%20city%2C%20dynamic%20lighting%20with%20strong%20contrast%2C%20painterly%20style%2C%20wide%20landscape%20composition&width=1600&height=900&seq=hero-slide-004&orientation=landscape',
    to: '/detail/comics/comic-010',
  },
];